module.exports = __webpack_public_path__ + "img/callcenterEspecialista.bcd291a7.png";